interface ITypeWithWeight {
  weight: number;
}

export function sortByWeight<T extends ITypeWithWeight>(arr: T[]) {
  return arr.sort((a, b) => a.weight - b.weight);
}
